import { useSelector } from "react-redux";

import { selectAreMailboxesSetUp } from "store/entities/email-domains";
import { selectDefaultMailboxDescription, selectDefaultTeamId } from "store/entities/license";
import { IMailbox } from "store/entities/mailboxes/interfaces";

export const useDefaultInbox = (): IMailbox => {
  const description = useSelector(selectDefaultMailboxDescription);
  const teamId = useSelector(selectDefaultTeamId);
  const inboxUsed = useSelector(selectAreMailboxesSetUp);
  return {
    id: "default",
    name: "",
    teamId,
    description,
    flags: {
      inboxUsed,
    },
  };
};
